import React from 'react';
import {
  Layout,
  Sidebar,
  Main
} from '@mulesoft/exchange-ui-components/lib/components/Layout';
import classNames from 'classnames';
import DetailWrapper from './DetailWrapper';
import ProductHeading from '~/components/ProductHeading';
import styles from './BaseLayout.css';

class BaseLayout extends React.Component {
  showProductHeading = false;

  renderSidebar() {
    return null;
  }

  renderMain() {
    return null;
  }

  renderDetail() {
    return null;
  }

  render() {
    const sidebar = this.renderSidebar();
    const main = this.renderMain();
    const detail = this.renderDetail();
    const layoutClassName = classNames(styles.layout, {
      [styles.flexContainer]: this.showProductHeading
    });

    return (
      <Layout className={layoutClassName}>
        <ProductHeading display-if={this.showProductHeading} />
        {sidebar ? <Sidebar>{sidebar}</Sidebar> : null}
        <Main>{main}</Main>
        <DetailWrapper detail={detail} />
      </Layout>
    );
  }
}

export default BaseLayout;
